module.exports = __webpack_public_path__ + "19318ac31e2de97fa1f45f587c4ad94a.png";


//////////////////
// WEBPACK FOOTER
// ./content/mupit/fENSP00000380152_7.png
// module id = 1332
// module chunks = 0